export type RoomVisibility = "private" | "public";

export interface Room {
  id: string;
  user_id: string;
  name: string;
  description: string | null;
  visibility: RoomVisibility;
  public_slug: string | null;
  content_count: number;
  created_at: string;
  team_id?: string | null;
}

export const getRoomPublicUrl = (room: Room) => {
  if (typeof window === "undefined") return "";
  const slug = room.public_slug ?? room.id;
  return `${window.location.origin}/r/${slug}`;
};
